import React from 'react';
import { List, Button, Typography } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const ListaReglamento = ({
  listaDeItems,
  idAsociacion,
}) => {

  // console.log("id que llega", idAsociacion)
  const handleDownload = (archivo) => {
    if (!archivo) {
      console.warn("No hay archivo disponible para descargar.");
      return;
    }

    const url = `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${idAsociacion}/PDFS/${archivo}`;
    window.open(url, "_blank"); // Abre el archivo en una nueva pestaña
  };

  return (
    <List className='contenedor-lista'
      style={{ display: "flex", flexDirection: "row", width: "100%" }}
      itemLayout="horizontal"
      dataSource={listaDeItems}
      renderItem={(item) => (
        <List.Item
        key={item.key}
          actions={[
            <Button
              type="link"
              icon={<DownloadOutlined />}
              onClick={() => handleDownload(item.archivo)}
              disabled={!item.archivo} // Deshabilita el botón si no hay archivo
              className="icono-descarga"
            >
              
            </Button>,
          ]}
        >
          <List.Item.Meta
            title={<Text>{item.nombre}</Text>}
            description={<Text type="secondary">{`Año: ${item.fecha}`}</Text>}
          />
        </List.Item>
      )}
    />
  );
};


